export class CompleteProfile {
    constructor(
        public address: string,
        public zip: string,
        public city: string,
        public state: string,
        public phone: string,
        public birthday: string
    ) {}
}


// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/routes/completeprofile/completeprofile.ts